import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {};

type RequestBody = {
  bestSellerCategoriesIds: string[];
};

const updateFooterInfo = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminPageBuilder/updateFooterInfo',
    method: 'PATCH',
    body,
  });

export { updateFooterInfo };
